module.exports = __webpack_public_path__ + "static/media/fundef-acordo.5544f395.webp";